import React, { useState, useEffect } from "react";
import { Card, CardBody, Row, Col, Spinner } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import axiosInstance from "../../helpers/axiosInstance";
import "./dashboard.scss";

const SalesAnalytics = () => {
  const [loading, setLoading] = useState(true);
  const [orderStats, setOrderStats] = useState(null);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/api/v1/admin/dashboard");
      const { byStatus } = response.data.stats.orders;
      setOrderStats(byStatus);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getChartData = () => {
    if (!orderStats) return null;

    const series = Object.values(orderStats);
    const labels = Object.keys(orderStats).map(
      (status) => status.charAt(0).toUpperCase() + status.slice(1)
    );

    return {
      series,
      options: {
        labels,
        plotOptions: {
          pie: {
            donut: {
              size: "75%",
              labels: {
                show: true,
                name: {
                  show: true,
                },
                value: {
                  show: true,
                  formatter: (val) => val,
                },
                total: {
                  show: true,
                  label: "Total Orders",
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                  },
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          position: "bottom",
          horizontalAlign: "center",
          show: true,
        },
        colors: [
          "#5664d2", // pending
          "#1cbb8c", // confirmed
          "#eeb902", // processing
          "#2ab57d", // shipped
          "#4ba6ef", // delivered
          "#fd625e", // cancelled
        ],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
    };
  };

  const getPercentage = (value) => {
    if (!orderStats) return 0;
    const total = Object.values(orderStats).reduce((a, b) => a + b, 0);
    return ((value / total) * 100).toFixed(1);
  };

  if (loading) {
    return (
      <Card>
        <CardBody>
          <div className="text-center">
            <Spinner color="primary" />
          </div>
        </CardBody>
      </Card>
    );
  }

  const chartData = getChartData();
  if (!chartData) return null;

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="card-title mb-0">Order Status Analytics</h4>
          </div>

          <div id="donut-chart" className="apex-charts">
            <ReactApexChart
              options={chartData.options}
              series={chartData.series}
              type="donut"
              height="280"
            />
          </div>

          <Row className="mt-4">
            {Object.entries(orderStats).map(([status, count], index) => (
              <Col xs={4} key={status}>
                <div className="text-center mt-4">
                  <p className="mb-2 text-truncate">
                    <i
                      className={`mdi mdi-circle text-${
                        index === 0
                          ? "primary"
                          : index === 1
                          ? "success"
                          : index === 2
                          ? "warning"
                          : index === 3
                          ? "info"
                          : index === 4
                          ? "primary"
                          : "danger"
                      } font-size-10 me-1`}
                    ></i>
                    {status.charAt(0).toUpperCase() + status.slice(1)}
                  </p>
                  <div>
                    <h5 className="mb-1">{count}</h5>
                    <p className="text-muted mb-0">{getPercentage(count)}%</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default SalesAnalytics;
